(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmt-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Silent autoplay only while on screen; never for reduced-motion visitors (they get the cover + controls).
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.play().catch(() => {});
        } else {
          entry.target.pause();
        }
      }
    }, { threshold: 0.35 });
    for (const video of document.querySelectorAll('[data-nmt-autoplay]')) observer.observe(video);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmt-finish-picker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nmt-finish-picker')) {
    customElements.define('nmt-finish-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.inputs = [...this.querySelectorAll('input[type="radio"]')];
        this.fitLink = this.querySelector('[data-finish-continue]');
        this.instructions = this.querySelector('[data-finish-instructions]');
        this.selectedInput = this.inputs.find(input => input.checked) || this.inputs[0];
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hoverPreference = window.matchMedia('(min-width: 750px) and (any-hover: hover)');
        this.onHoverChange = () => this.updateInstructions();
        this.onPageShow = () => {
          cancelAnimationFrame(this.restoreFrame);
          this.restoreFrame = requestAnimationFrame(() => {
            this.selectFinish(this.inputs.find(input => input.checked) || this.selectedInput);
          });
        };
        this.events = {
          pointerdown: event => {
            this.lastPointerType = event.pointerType;
            this.updateInstructions();
          },
          pointerover: event => {
            if (event.pointerType === 'touch') return;
            const swatch = event.target.closest('.nmt-finish-picker__swatch');
            if (!swatch || swatch.contains(event.relatedTarget)) return;
            this.lastPointerType = event.pointerType;
            this.updateInstructions();
            this.selectFinish(swatch.querySelector('input'));
          },
          focusin: event => {
            if (this.inputs.includes(event.target)) this.selectFinish(event.target);
          },
          change: event => {
            if (this.inputs.includes(event.target)) this.selectFinish(event.target);
          },
          keydown: event => {
            if (event.key !== 'Enter' || event.altKey || event.ctrlKey || event.metaKey) return;
            if (!this.inputs.includes(event.target)) return;
            event.preventDefault();
            this.selectFinish(event.target);
            this.fitLink.click();
          },
          click: event => {
            if (this.inputs.includes(event.target)) {
              this.selectFinish(event.target);
              const pointerType = event.pointerType || this.lastPointerType;
              const directClick = event.detail > 0 && pointerType !== 'touch' && this.hoverPreference.matches;
              if (directClick && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) this.fitLink.click();
              return;
            }
            if (event.target.closest('[data-finish-continue]') !== this.fitLink) return;
            if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
            this.continueToFit(event);
          }
        };
        Object.entries(this.events).forEach(([type, handler]) => this.addEventListener(type, handler));
        this.hoverPreference.addEventListener('change', this.onHoverChange);
        this.updateInstructions();
        if (this.selectedInput) this.showFinish(this.selectedInput);
        window.addEventListener('pageshow', this.onPageShow);
        this.onPageShow();
      }

      updateInstructions() {
        const desktop = this.hoverPreference.matches && this.lastPointerType !== 'touch';
        this.instructions.textContent = desktop
          ? 'Hover to preview. Click a color to find your fit.'
          : 'Tap a color to preview. Then find your fit.';
        this.instructions.hidden = false;
      }

      selectFinish(input) {
        if (!this.inputs.includes(input)) return;
        this.selectedInput = input;
        input.checked = true;
        this.showFinish(input);
      }

      continueToFit(event) {
        this.selectFinish(this.inputs.find(input => input.checked) || this.selectedInput);
        const url = new URL(this.fitLink.href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
        const finder = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (!finder?.matches('[data-nmt-ff]') || !this.selectedInput) return;
        event.preventDefault();
        const color = this.selectedInput.dataset.name;
        finder.dataset.ffSelectedColor = color;
        finder.dispatchEvent(new CustomEvent('nmt:choose-color', { detail: { color, focus: true } }));
        if (window.location.hash !== url.hash) window.history.pushState(null, '', url.hash);
        finder.scrollIntoView({ block: 'start', behavior: this.motionPreference.matches ? 'auto' : 'smooth' });
      }

      showFinish(input) {
        const hex = input.dataset.color.replace('#', '');
        const expanded = hex.length === 3 ? [...hex].map(value => value + value).join('') : hex;
        if (!/^[0-9a-f]{6}$/i.test(expanded)) return;
        const channels = [0, 2, 4].map(offset => parseInt(expanded.slice(offset, offset + 2), 16) / 255);
        this.querySelectorAll('[data-mount-channel]').forEach((channel, index) => {
          channel.setAttribute('slope', '1.2');
          channel.setAttribute('intercept', String(Math.max(0, channels[index] * 0.82 - 0.08)));
        });
        this.querySelector('[data-mount-overlay]').setAttribute('opacity', input.dataset.name.toLowerCase() === 'black' ? '0' : '1');
        this.querySelector('[data-finish-scene]').setAttribute('aria-label', input.dataset.name + ' mount on a white Stanley cup');
        this.querySelector('[data-finish-name]').textContent = input.dataset.name;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.restoreFrame);
        window.removeEventListener('pageshow', this.onPageShow);
        Object.entries(this.events).forEach(([type, handler]) => this.removeEventListener(type, handler));
        this.hoverPreference.removeEventListener('change', this.onHoverChange);
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
